
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ProductAnalyticsGrid extends Serenity.EntityGrid<ProductAnalyticsRow, any> {
        protected getColumnsKey() { return 'Workspace.ProductAnalytics'; }
        protected getDialogType() { return ProductAnalyticsDialog; }
        protected getIdProperty() { return ProductAnalyticsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductAnalyticsRow.localTextPrefix; }
        protected getService() { return ProductAnalyticsService.baseUrl; }
        private nextId = 1;
        private rowSelection: Serenity.GridRowSelectionMixin;
        constructor(container: JQuery) {
            super(container);
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected onViewProcessData(response: Serenity.ListResponse<RecordShield.Workspace.ProductAnalyticsRow>) {
            response = super.onViewProcessData(response);

            // there is no __id property in CustomerGrossSalesRow but 
            // this is javascript and we can set any property of an object
            for (var x of response.Entities) {
                (x as any).__id = this.nextId++;
            }
            return response;
        }

        protected getQuickFilters() {
            debugger;
            var filters = super.getQuickFilters();

            // we create a date-range quick filter, which is a composite
            // filter with two date time editors
            var InvoiceDate = this.dateRangeQuickFilter('InsertDate', 'Insert Date');

            // need to override its handler, as default date-range filter will set Criteria parameter of list request.
            // we need to set StartDate and EndDate custom parameters of our CustomerGrossSalesListRequest
            InvoiceDate.handler = args => {

                // args.widget here is the start date editor. value of a date editor is a ISO date string
                var start = args.widget.value;

                // to find end date editor, need to search it by its css class among siblings
                var end = args.widget.element.nextAll('.s-DateEditor')
                    .getWidget(Serenity.DateEditor).value;

                (args.request as ProductAnalyticsListRequest).StartDate = start;
                (args.request as ProductAnalyticsListRequest).EndDate = end;

                // active option controls when a filter editor looks active, e.g. its label is blueish
                args.active = !Q.isEmptyOrNull(start) || !Q.isEmptyOrNull(end);
            };

            filters.push(InvoiceDate);

            return filters;
        }
        protected getButtons() {
            var buttons = [];

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: ProductAnalyticsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            buttons.push({
                title: "View Top 5 Seen Lectures",
                cssClass: 'edit-permissions-button ',
                icon: 'icon-lock-open text-green',
                onClick: () => {
                    debugger;
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0 || rowKeys.length > 1) {
                        Q.alert("Please select single Product!");
                        return;
                    }
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    var key = this.rowSelection.getSelectedKeys()[0];
                    //new DutyBulkCreationDialog(this, false, this.form.RequestedVehiceTypeId, this.form.SourceDateTime, this.form.EndTime).loadNewAndOpenDialog();
                    var topSeenLectureDialog: TopSeenLectureDialog = new Workspace.TopSeenLectureDialog();
                    //topSeenLectureDialog.productAnalyticsForm = this.form;
                    topSeenLectureDialog.ProductId = key;
                  
                    topSeenLectureDialog.dialogOpen();
                }
            });
            return buttons;
        }
    }
}